// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1ODbA","ranges":"BmiRanges_ranges__1gWVR"};